import { Container, Row } from "reactstrap";
import WebsiteDesign from "./WebsiteDesign/WebsiteDesign";
import Visitors from "./Visitors/Visitors";
import SocialWidget from "./SocialWidget/SocialWidget";
import UpcomingAppointment from "./UpcomingAppointment/UpcomingAppointment";
import TotalStudents from "./TotalStudents/TotalStudents";
import OpeningOfLeaflets from "./OpeningOfLeaflets/OpeningOfLeaflets";
import TotalSells from "./TotalSells/TotalSells";


const ContainerGeneral = () => {
  return (
    <Container fluid className="general-page">
      <Row>
        <TotalSells />
        <WebsiteDesign />
        <OpeningOfLeaflets />
        <Visitors />
        <SocialWidget />
        <TotalStudents />
        <UpcomingAppointment />
      </Row>
    </Container>
  );
};

export default ContainerGeneral;
